import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { bindActionCreators } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { useAuth } from '../core/Auth';
import { getBorrowerByToken } from '../core/_requests';
import { listConstants } from '../../../app/modules/Constants/_constants.service';
import { creators } from '../../../app/state';
import { getLead, getLeadProgramAccounts } from '../../../app/modules/Crm/_crm.service';
import { getProgramConfig } from '../../../app/modules/Datum/_datum.service';
import { alertSuccess } from '../../../app/helpers/alert';
import * as authHelper from '../core/AuthHelpers';

const RefreshLogin = () => {
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const { saveAuth, setCurrentUser } = useAuth();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { setConstants } = bindActionCreators(creators, dispatch);

    const initConstants = async () => {
        const data = await listConstants();
        setConstants(data);
    };

    useEffect(() => {
        const initRefreshLogin = async () => {
            const authToken = searchParams.get('auth_token');
            const refreshToken = searchParams.get('refresh_token');
            const user_type = searchParams.get('user_type');
            const readonly = searchParams.get('readonly');
            const silent = searchParams.get('silent');

            if (!authToken || !refreshToken || user_type !== 'borrower') {
                navigate('/auth/login');
                return;
            }

            try {
                if (silent === 'true') localStorage.setItem('silent_auth', 'true');
                saveAuth({ access: authToken, refresh: refreshToken });
                localStorage.setItem('user_type', 'borrower');
                localStorage.setItem(
                    'crego-auth',
                    JSON.stringify({ access: authToken, refresh: refreshToken })
                );

                const { data: user } = await getBorrowerByToken();

                const tmp = {};
                const serviceAccounts = await getLeadProgramAccounts(user.lead_id, user.program_id);
                Object.entries(serviceAccounts).forEach(([key, value]) => {
                    if (value?.length) {
                        tmp[key] = value[0];
                    }
                });

                user.service_accounts = tmp;
                user.user = await getLead(user.lead_id);
                user.user_type = 'borrower';
                user.program_config = await getProgramConfig(user.program_id);

                if (readonly === 'true') {
                    user.permissions = [...(user.permissions || []), 'readonly'];
                }
                authHelper.extractAndSaveNavVariables();
                setCurrentUser(user);
                await initConstants();
                if (silent !== 'true') alertSuccess('User authenticated successfully');
                navigate('/');
            } catch (err) {
                saveAuth(undefined);
                localStorage.removeItem('user_type');
                localStorage.removeItem('silent_auth');
                setError('Authentication failed. Please try again.');
                setLoading(false);
            }
        };

        initRefreshLogin();
    }, []);

    if (error) {
        return (
            <div className='text-center'>
                <div className='text-danger mb-5'>{error}</div>
                <a
                    href='/auth/login'
                    className='btn btn-primary'>
                    Go to Login
                </a>
            </div>
        );
    }

    return (
        <div className='text-center'>
            {loading && (
                <span
                    className='indicator-progress'
                    style={{ display: 'block' }}>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
            )}
        </div>
    );
};

export default RefreshLogin;
